import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import ODC from "@/components/ODC";
import StaffAugmentation from "@/components/StaffAugmentation";
import SEOHead from "@/components/SEOHead";
import SkipLink from "@/components/SkipLink";
import { useSEO } from "@/hooks/useSEO";

const ODCPage = () => {
  useSEO({
    title: "Offshore Development Center (ODC) & Staff Augmentation | Smartborn",
    description: "Set up your dedicated offshore development center in India or augment your team with skilled developers. Flexible engagement models, 200+ expert developers, cost-effective solutions.",
    keywords: "offshore development center, ODC, staff augmentation, dedicated development team, offshore developers, IT outsourcing, remote development team, developer hiring",
    canonical: "https://smartborn.io/odc",
    ogType: "website"
  });

  return (
    <>
      <div className="min-h-screen">
        <SEOHead />
        <SkipLink />
        <Navigation />
        <main id="main-content" tabIndex={-1}>
          <ODC />
          <StaffAugmentation />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default ODCPage;
